"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverrideLocale = exports.OVERWRITE_LOCALE_MAP = void 0;
const Formatter_types_1 = require("../Formatter.types");
exports.OVERWRITE_LOCALE_MAP = {
    "en-AE": "en-GB",
    "en-SG": "en-GB",
    "es-419": "es",
};
function getOverrideLocale(envLocale) {
    if (Formatter_types_1.TMS_SUPPORTED_LOCALES.includes(envLocale)) {
        return envLocale;
    }
    if (exports.OVERWRITE_LOCALE_MAP[envLocale]) {
        return exports.OVERWRITE_LOCALE_MAP[envLocale];
    }
    return "en";
}
exports.getOverrideLocale = getOverrideLocale;
//# sourceMappingURL=GetOverrideLocale.js.map